interface LogoProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Logo: React.FC<LogoProps> = ({
  color = "#2625e9",
  size = 40,
  ...props
}) => (
  <svg
    viewBox="0 0 53 30.98"
    width={size}
    height={size}
    aria-hidden="true"
    {...props}
    className={props.className}  
  >
 <path fill={color} d="M49.42,30.98c-.12-.02-.1-.13-.12-.21-.93-3.59-1.73-6.42-3.49-9.74-4.65-8.77-13.39-13.69-23.42-12.55S5.04,17.55,2.36,27.16c-.34,1.23-.63,2.54-.7,3.82-.3-.41-.51-1.05-.67-1.55C-2.99,17.2,5.54,4.87,17.15,1.23c12.59-3.95,26.71,1.84,31.81,14.16,2.06,4.97,2.26,10.5.46,15.59ZM49.24,26.25c.13-2.21.07-4.39-.39-6.55C44.81.75,19.92-4.87,7.15,9.13,3.01,13.68,1.13,19.16,1.48,25.31c0,.25-.03.55,0,.79,0,.08.04.19.12.09C3.69,17.07,10.68,9.62,19.92,7.64c12.68-2.72,24.37,4.39,28.59,16.39.23.67.38,1.36.6,2.01.03.08.02.19.13.2h0Z"/>
  <path fill={color} d="M40.51,30.98l-.06-.58c.34-4.47-.13-8.72-2.8-12.43-6.2-8.62-19.23-8.46-25.1.42-2.5,3.77-2.44,8.09-2.14,12.46-.18.03-.1-.05-.14-.13-4.18-8.5,2.31-17.67,10.74-19.81s17.86,2.74,20.19,11.21c.82,2.98.57,6.06-.7,8.86h.01Z"/>
  <path fill={color}  d="M40.2,30.68l-1.22-2.93c-1.97-4.07-4.55-8.2-8.87-10.06-5.4-2.32-11.27-.59-14.91,3.87-2.13,2.61-3.74,5.96-4.67,9.19-.11,0-.07-.26-.06-.34.31-6.8,5.01-13.37,11.89-14.69,6.27-1.2,11.86,1.69,15.14,6.96,1.47,2.36,2.56,5.2,2.7,8Z"/>
  <g>
    <path fill={color} d="M34.4,30.68l-.04-.35c.2-2.67-.08-5.21-1.67-7.43-3.71-5.15-11.49-5.06-15,.25-1.49,2.25-1.46,4.84-1.28,7.45-.11.02-.06-.03-.08-.08-2.5-5.08,1.38-10.56,6.42-11.84,5.04-1.28,10.67,1.64,12.07,6.7.49,1.78.34,3.62-.42,5.3h0Z"/>
    <path fill={color} d="M34.21,30.94l-.73-1.75c-1.18-2.43-2.72-4.9-5.3-6.01-3.23-1.39-6.74-.35-8.91,2.31-1.27,1.56-2.24,3.56-2.79,5.49-.07,0-.04-.16-.04-.2.19-4.06,2.99-7.99,7.11-8.78,3.75-.72,7.09,1.01,9.05,4.16.88,1.41,1.53,3.11,1.61,4.78Z"/>
  </g>
  </svg>
);

export default Logo;